module.exports = __webpack_public_path__ + "fonts/ef68fac.ttf";